<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Entrega Folio:{{folio}}
            <div>
              <router-link :to="{
                      name: 'EditEntrega',
                      params: {
                        folio: folio,
                        config: config
                      }
                    }">
                <CButton v-if="false" color="success" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-pencil" />Editar
                </CButton>
              </router-link>
              <CButton color="info" class="mr-1 btn-header" @click="getReporte">
                <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
              </CButton>
              <router-link :to="{ name: 'Entrega', params: { config: config } }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </router-link>
            </div>
          </CCardHeader>

          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CCol sm="12" class="text-right">
              {{ this.item.author.correo }}
            </CCol>
            <CRow>
              <CCol>
                <label>Fecha:</label>
                <CInput v-model="date" disabled type="date" horizontal />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Cliente:</label>
                <CInput
                  v-model="cliente"
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Folio Cliente:</label>
                <CInput
                  v-model="folio_cliente"
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Folio Factura:</label>
                <CInput
                  v-model="folio_factura"
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Cultivo:</label>
                <CInput
                  v-model="cultivo"
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Embalaje:</label>
                <CInput
                  v-model="embalaje"
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                <CInput
                  v-model="calidad"
                  disabled
                  label="Calidad"
                  placeholder="Calidad..."
                  type="text"
                />
              </CCol>
            </CRow>
            <CRow v-if="peso != 0">
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="peso"
                  disabled
                  label="Peso (kg.):"
                  placeholder="Peso kg."
                  type="number"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                <CInput
                  v-model="cantidad"
                  disabled
                  label="Cantidad"
                  placeholder="Cantidad..."
                  type="number"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="9" md="9" lg="9">
                <label>Ubicaciones:</label>
                <multiselect
                  v-model="multi"
                  :options="ubicaciones"
                  disabled
                  :multiple="true"
                  label="label"
                  track-by="label"
                  placeholder="Selecciona uno o varias ubicaciones"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Comentarios:</label>
                <CTextarea v-model="comentarios" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="onFetch"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <CRow>
              <CButton v-if="fetching" class="px-4 mx-3 btn-lg" color="success">
                <i class="fa fa-spinner fa-pulse"></i>
              </CButton>
              <CButton v-else @click="()=>{fetching=true}" class="px-4 mx-3 btn-lg" color="success">
                <span>Actualizar</span>
              </CButton>
            </CRow>
            <CModal
              size="sm"
              title="Entrega"
              :centered="true"
              color="warning"
              :show.sync="warningModal"
            >{{ error }}</CModal>
            <CModal
              size="sm"
              title="Entrega"
              :centered="true"
              color="success"
              :show.sync="successModal"
              >Guardado con éxito.
              <template #footer>
                <CButton @click="successModal = false"  color="success">Aceptar</CButton>
              </template>
            </CModal>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "VerEntrega",

  components: {
    Multiselect
  },

  data() {
    return {
      folio: this.$route.params.id,
      config: this.$route.params.config,
      folio_cliente: '',
      folio_factura: '',
      item: {},
      date: null,
      cantidad: 1,
      peso: 0,
      calidad: "",
      cultivo: null,
      cliente: null,
      ubicaciones: [],
      ubicacion: null,
      embalaje: null,
      ubicacionesAll: [],
      multi: null,
      isLoading: false,
      embalajes: [],
      comentarios: '',
      successModal: false,
      warningModal: false,
      error: "",
      isLoadingPage: false,
      currentAlertCounter: 0,
      fetching: false,
      medias:[],
      loader: false,
    };
  },

  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  created() {
    this.isLoading = true;
    this.$store;

    const serv = [
      this.$store.dispatch("customDocumentoHTTP", {
        schema: "entregas",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"]: ["*"]
      })
    ];

    Promise.all(serv)
      .then(([item]) => {
        this.item = item.data[0];
        const variedad = this.item.payload.encabezado._relaciones.cultivo.payload.variedad || ''
        this.cultivo = `${this.item.payload.encabezado._relaciones.cultivo.payload.nombre} ${variedad}`;
        this.cliente = this.item.payload.encabezado.cliente_id?`${this.item.payload.encabezado._relaciones.cliente.payload.nombre}`:'';
        this.folio_cliente = this.item.payload.encabezado?.folio_cliente||'';
        this.folio_factura = this.item.payload.encabezado?.folio_factura||'';
        this.embalaje =this.item.payload.encabezado.embalaje;
        this.cantidad = this.item.payload.encabezado.cantidad;
        this.peso = this.item.payload.encabezado.peso;
        this.calidad = this.item.payload.encabezado.calidad;
        this.comentarios = this.item.payload.encabezado.comentarios;
        this.medias = this.item.payload.anexos;

        const newMult = this.item.payload.encabezado._relaciones.ubicacion
            .filter(ubi => ubi.id)
            .map(ubicacion => {
              return { value: ubicacion.id, label: ubicacion.payload.nombre };
            });
        this.multi = newMult;

        let dateDocto = new Date(this.item.payload.encabezado.fechahora);

        let year = dateDocto.getFullYear();
        let month = ("0" + (dateDocto.getMonth() + 1)).slice(-2);
        let day = ("0" + dateDocto.getDate()).slice(-2);

        this.date = `${year}-${month}-${day}`;
      })
      .finally(() => (this.isLoading = false));
  },

  methods: {
    getReporte(){
      if(this.loader){
        return
      }
      this.loader = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_entregas",
        params: { folio:this.$route.params.id, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);


        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte de entregas.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader = false
          this.$forceUpdate();
        });
    },
    async onFetch(medias){
      this.fetching=false
      const {folio,serie,schema,payload} = this.item
      const body = Object.assign({},JSON.parse(JSON.stringify({folio,serie,schema,payload})))
      body.payload.anexos = medias
      delete body.payload.encabezado._relaciones
      this.$store.dispatch("customDocumentoRemplazarHTTP",body)
        .then(()=>{
          this.currentAlertCounter = 6;
            // console.log(res.data);
            // this.$router.push({ name: "Produccion" });
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.fetching=false
          return;
        })

        .finally(() => {
          this.fetching=false
          if (!this.warningModal) {
            this.successModal = true;
          }
        });

    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;
        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
